export function scrollTo(elem, margin = 0) {
  let position =
    elem.getBoundingClientRect().top -
    document.body.getBoundingClientRect().top -
    (document.querySelector('.header') as HTMLElement)?.offsetHeight -
    margin;
  window.scrollTo({ top: position, behavior: 'smooth' });
}

export function isInViewport(elem) {
  let elemBounding = elem.getBoundingClientRect();
  var elemHeight = elem.offsetHeight;
  var elemWidth = elem.offsetWidth;

  if (
    elemBounding.top >= -elemHeight &&
    elemBounding.left >= -elemWidth &&
    elemBounding.right <=
      (window.innerWidth || document.documentElement.clientWidth) + elemWidth &&
    elemBounding.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) + elemHeight
  ) {
    return true;
  } else {
    return false;
  }
}

export function getViewPercentage(element) {
  const viewport = {
    top: window.scrollY,
    bottom: window.scrollY + window.innerHeight
  };

  const elementBoundingRect = element.getBoundingClientRect();
  const elementPos = {
    top: elementBoundingRect.y + window.pageYOffset,
    bottom:
      elementBoundingRect.y + elementBoundingRect.height + window.pageYOffset
  };

  if (viewport.top > elementPos.bottom || viewport.bottom < elementPos.top) {
    return 0;
  }

  // Element is fully within viewport
  if (viewport.top < elementPos.top && viewport.bottom > elementPos.bottom) {
    return 100;
  }

  // Element is bigger than the viewport
  if (elementPos.top < viewport.top && elementPos.bottom > viewport.bottom) {
    return 100;
  }

  const elementHeight = elementBoundingRect.height;
  let elementHeightInView = elementHeight;

  if (elementPos.top < viewport.top) {
    elementHeightInView = elementHeight - (window.pageYOffset - elementPos.top);
  }

  if (elementPos.bottom > viewport.bottom) {
    elementHeightInView =
      elementHeightInView - (elementPos.bottom - viewport.bottom);
  }

  const percentageInView = (elementHeightInView / window.innerHeight) * 100;

  return Math.round(percentageInView);
}

export function disableScroll(value) {
  if (value == true) {
    var x = window.scrollX;
    var y = window.scrollY;
    window.onscroll = function () {
      window.scrollTo(x, y);
    };
  } else {
    window.onscroll = function () {};
  }
}

export function isMobile() {
  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(
      navigator.userAgent
    ) ||
    window.innerWidth < 1025
  )
    return true;
  return false;
}
